var map = {
	"./blitz_left.jpg": "3201",
	"./blitz_right.jpg": "30f6",
	"./completion_left.jpg": "4a35",
	"./completion_left_2.jpg": "cc9e",
	"./completion_right.jpg": "ee19",
	"./completion_right_2.jpg": "9c32",
	"./defense_recovered_left.jpg": "7820",
	"./defense_recovered_right.jpg": "2097",
	"./fair_catch_left.jpg": "bcf6",
	"./fair_catch_right.jpg": "80aa",
	"./field_goal_left.jpg": "59c9",
	"./field_goal_right.jpg": "eb16",
	"./first_down_failed.jpg": "28bf",
	"./first_down_left.jpg": "1d57",
	"./first_down_right.jpg": "7436",
	"./fumble.jpg": "ae12",
	"./incomplete_left.jpg": "83bb",
	"./incomplete_right.jpg": "7bbc",
	"./interception_left.jpg": "a0a3",
	"./interception_right.jpg": "d4aa",
	"./off_tackle_left.jpg": "9c65",
	"./off_tackle_right.jpg": "4b43",
	"./out_of_bounds_left.jpg": "386f",
	"./out_of_bounds_right.jpg": "444e",
	"./overtime.jpg": "749f",
	"./pass_left.jpg": "ac9b",
	"./pass_left_2.jpg": "1141",
	"./pass_right.jpg": "8208",
	"./pass_right_2.jpg": "f0fb",
	"./pitch_play_left.jpg": "c664",
	"./pitch_play_right.jpg": "d797",
	"./punt_left.jpg": "6b8b",
	"./punt_right.jpg": "ada4",
	"./reverse_left.jpg": "7e00",
	"./reverse_right.jpg": "960a",
	"./run_left.jpg": "d99d",
	"./run_right.jpg": "7bb7",
	"./sack_left.jpg": "a579",
	"./sack_right.jpg": "980a",
	"./safety.jpg": "2c09",
	"./tackled_left.jpg": "f90e",
	"./tackled_right.jpg": "2bdc",
	"./touchback_left.jpg": "179d",
	"./touchback_right.jpg": "4eb2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e7f7";